import { DateRangePresetKey } from '../../../pods/dashboard/components/DashboardFilters/useDefaultDateRangePresets';

export const eosDateRangeFilterVisiblePresets: DateRangePresetKey[] = [
  DateRangePresetKey.TODAY,
  DateRangePresetKey.YESTERDAY,
  DateRangePresetKey.LAST3DAYS,
  DateRangePresetKey.LAST7DAYS,
  DateRangePresetKey.LAST30DAYS,
  DateRangePresetKey.THISMONTH,
  DateRangePresetKey.LASTMONTH,
  DateRangePresetKey.LAST6MONTHS,
  DateRangePresetKey.THISYEAR,
  DateRangePresetKey.LASTYEAR,
  DateRangePresetKey.CUSTOM,
];
